module.exports = __webpack_public_path__ + "a967966eca24aa4429de00b926e28501.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/lobbyviewsmall.png
// module id = 921
// module chunks = 7